var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g, _path28, _path29, _path30, _path31, _g2, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyAnalyticsTopic = function SvgEmptyAnalyticsTopic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 250,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalyticsTopic_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalyticsTopic_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "EmptyAnalyticsTopic_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "EmptyAnalyticsTopic_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C9E4",
    offset: "32.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "99.998%",
    y2: "49.999%",
    id: "EmptyAnalyticsTopic_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF6B",
    offset: "1.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38764",
    offset: "34.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5E60",
    offset: "63.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5455D",
    offset: "86.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E33C5C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "EmptyAnalyticsTopic_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEF0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CCE7",
    offset: "55.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC3E3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "99.998%",
    y2: "49.999%",
    id: "EmptyAnalyticsTopic_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF6B",
    offset: "1.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38764",
    offset: "34.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5E60",
    offset: "63.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5455D",
    offset: "86.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E33C5C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.306%",
    y1: "67.513%",
    x2: "77.669%",
    y2: "31.126%",
    id: "EmptyAnalyticsTopic_svg__h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E8F5",
    offset: "54.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalyticsTopic_svg__i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "EmptyAnalyticsTopic_svg__j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5F1",
    offset: ".7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAECF9",
    offset: "38.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "73.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "EmptyAnalyticsTopic_svg__k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5F1",
    offset: ".7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAECF9",
    offset: "38.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "73.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "EmptyAnalyticsTopic_svg__l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5F1",
    offset: ".7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAECF9",
    offset: "38.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "73.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "EmptyAnalyticsTopic_svg__m"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8E7",
    offset: "42.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CEEA",
    offset: "55.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDEF1",
    offset: "74.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9FD",
    offset: "96.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.487%",
    y1: "-4.568%",
    x2: "39.705%",
    y2: "104.724%",
    id: "EmptyAnalyticsTopic_svg__o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D33",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.647%",
    y1: "-1.92%",
    x2: "43.275%",
    y2: "89.791%",
    id: "EmptyAnalyticsTopic_svg__r"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3192",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "99.998%",
    y2: "49.999%",
    id: "EmptyAnalyticsTopic_svg__t"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF6B",
    offset: "1.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38764",
    offset: "34.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5E60",
    offset: "63.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5455D",
    offset: "86.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E33C5C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "99.999%",
    y2: "50%",
    id: "EmptyAnalyticsTopic_svg__u"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3EC",
    offset: "9.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBF6",
    offset: "40.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "68.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "89.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.001%",
    y1: "50.003%",
    x2: "100%",
    y2: "50.003%",
    id: "EmptyAnalyticsTopic_svg__v"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3EC",
    offset: "9.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBF6",
    offset: "40.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "68.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "89.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "EmptyAnalyticsTopic_svg__w"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423EAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A35A0",
    offset: "30.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241E77",
    offset: "89.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F196F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.468%",
    y1: "0%",
    x2: "51.153%",
    y2: "109.395%",
    id: "EmptyAnalyticsTopic_svg__x"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-5874.094%",
    y1: "50%",
    x2: "-5774.094%",
    y2: "50%",
    id: "EmptyAnalyticsTopic_svg__y"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423EAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A35A0",
    offset: "30.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241E77",
    offset: "89.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F196F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.115%",
    y1: "0%",
    x2: "51.918%",
    y2: "109.395%",
    id: "EmptyAnalyticsTopic_svg__z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "EmptyAnalyticsTopic_svg__A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7F5",
    offset: "66.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "EmptyAnalyticsTopic_svg__B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7F5",
    offset: "66.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.329 37.208 0 88.118a4.126 4.126 0 0 0 6.174 3.614L64.41 58.472a4.13 4.13 0 0 0 2.083-3.61L66.21 4.107A4.126 4.126 0 0 0 60.027.548L2.402 33.653a4.132 4.132 0 0 0-2.073 3.555Z",
    id: "EmptyAnalyticsTopic_svg__n"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.564 29.691-.143 47.456c-.014 4.308-4.672 6.997-8.41 4.856L3.41 58.708a5.611 5.611 0 0 1-2.82-4.803L0 5.694C-.053 1.33 4.665-1.422 8.434.77l41.34 24.05a5.611 5.611 0 0 1 2.79 4.871Z",
    id: "EmptyAnalyticsTopic_svg__q"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalyticsTopic_svg__a)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M84.676 78.08H32.575l32.57 19.399-32.57 18.822h52.1l33.069-19.105z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BEE4",
    fillRule: "nonzero",
    d: "m32.575 116.301 32.57-18.822V39.023L32.575 57.84v58.462z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1F6",
    fillRule: "nonzero",
    d: "M32.575 116.301 0 97.48V39.023L32.575 57.84v58.462z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F9",
    fillRule: "nonzero",
    d: "M32.575 57.84 0 39.022l32.575-18.81 32.57 18.81z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalyticsTopic_svg__b)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M283.908 139.352h-46.472l29.052 17.303-29.052 16.79h46.472l18.02-10.411.072-13.223-18.092-10.46z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BEE4",
    fillRule: "nonzero",
    d: "m237.436 173.444 29.052-16.789v-52.14l-29.052 16.783z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1F6",
    fillRule: "nonzero",
    d: "m237.436 173.444-29.055-16.789v-52.14l29.055 16.783z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F9",
    fillRule: "nonzero",
    d: "m237.436 121.298-29.055-16.783 29.055-16.778 29.052 16.778z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalyticsTopic_svg__c)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M243.237 202.605h-17.16l10.728 6.39-10.727 6.198h17.159l10.891-6.293-10.891-6.295z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#56B1B0",
    fillRule: "nonzero",
    d: "m226.078 215.193 10.727-6.199v-12.586l-10.727 6.197v12.588z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B7978",
    fillRule: "nonzero",
    d: "m226.078 215.193-10.73-6.199v-12.586l10.73 6.197v12.588z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#74DDDC",
    fillRule: "nonzero",
    d: "m226.078 202.605-10.73-6.197 10.73-6.195 10.727 6.195-10.727 6.197z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.377 150.63c-3.01-1.738-7.013-2.54-10.942-2.423h-9.112v1.011a16.31 16.31 0 0 0-3.26 1.412c-5.604 3.261-5.572 8.546.067 11.806a16.395 16.395 0 0 0 3.193 1.384v1.056h10.34c3.555-.06 7.077-.867 9.781-2.439 5.604-3.26 5.577-8.546-.067-11.807Z",
    fill: "url(#EmptyAnalyticsTopic_svg__d)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.783 156.934c-2.838-1.64-4.258-3.794-4.251-5.944l.012-2.754c-.005 2.153 1.411 4.305 4.251 5.946 5.643 3.26 14.76 3.26 20.365.001 2.785-1.621 4.179-3.739 4.186-5.862l-.014 2.752c-.006 2.123-1.4 4.241-4.184 5.862-5.605 3.26-14.722 3.26-20.365-.001Z",
    fill: "url(#EmptyAnalyticsTopic_svg__e)",
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.783 159.687c-2.838-1.641-4.258-3.794-4.251-5.944l.012-2.754c-.005 2.152 1.411 4.304 4.251 5.945 5.643 3.26 14.76 3.26 20.365.002 2.785-1.622 4.179-3.74 4.186-5.863l-.014 2.753c-.006 2.123-1.4 4.24-4.184 5.861-5.605 3.26-14.722 3.26-20.365 0Z",
    fill: "url(#EmptyAnalyticsTopic_svg__f)",
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.783 162.439c-2.838-1.641-4.258-3.794-4.251-5.944l.012-2.754c-.005 2.152 1.411 4.305 4.251 5.946 5.643 3.259 14.76 3.259 20.365 0 2.785-1.621 4.179-3.738 4.186-5.861l-.014 2.752c-.006 2.123-1.4 4.24-4.184 5.862-5.605 3.26-14.722 3.26-20.365-.001Z",
    fill: "url(#EmptyAnalyticsTopic_svg__g)",
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.795 154.182c-5.641-3.26-5.672-8.546-.068-11.804 5.606-3.26 14.726-3.26 20.366 0 5.644 3.258 5.67 8.545.067 11.805-5.606 3.258-14.722 3.258-20.365-.001Z",
    fill: "#F6F6FB",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.722 108.816c-10.08-5.822-23.48-8.504-36.64-8.112h-11.42v3.382a54.614 54.614 0 0 0-10.915 4.73c-18.763 10.92-18.654 28.612.227 39.53a54.6 54.6 0 0 0 10.687 4.634v3.533h15.536c11.901-.197 23.694-2.9 32.751-8.163 18.765-10.922 18.67-28.613-.226-39.534Z",
    fill: "url(#EmptyAnalyticsTopic_svg__h)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M110.72 148.352c-9.505-5.494-14.256-12.701-14.235-19.9l.042-7.279c-.018 7.206 4.725 14.411 14.232 19.908 18.896 10.91 49.42 10.91 68.185.005 9.326-5.43 13.993-12.52 14.016-19.63l-.044 7.274c-.018 7.107-4.686 14.197-14.008 19.626-18.766 10.916-49.296 10.916-68.187-.004Z",
    fill: "url(#EmptyAnalyticsTopic_svg__i)",
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.76 141.08c-18.887-10.912-18.992-28.61-.228-39.521 18.77-10.916 49.306-10.916 68.191 0 18.897 10.91 18.985 28.61.221 39.527-18.765 10.905-49.29 10.905-68.185-.005Z",
    fill: "#F5F5FA",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalyticsTopic_svg__j)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M123.848 231.49h-24.35l10.099 6.015-10.1 5.837h24.35l10.254-5.924z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalyticsTopic_svg__k)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M149.333 217.911H116.23l13.73 8.178-13.73 7.935h33.104l13.94-8.054z"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BEE4",
    fillRule: "nonzero",
    d: "m116.23 234.024 13.73-7.935v-32.202l-13.73 7.932v32.205z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1F6",
    fillRule: "nonzero",
    d: "m116.23 234.024-13.731-7.935v-32.202l13.73 7.932v32.205z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F9",
    fillRule: "nonzero",
    d: "m116.23 201.82-13.731-7.933 13.73-7.929 13.73 7.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalyticsTopic_svg__l)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M157.613 238.2h-22.73l9.427 5.989-9.428 5.811h22.731l9.572-5.898-9.572-5.903z"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BEE4",
    fillRule: "nonzero",
    d: "m134.882 250 9.428-5.811v-23.585l-9.428 5.81V250z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1F6",
    fillRule: "nonzero",
    d: "m134.882 250-9.428-5.811v-23.585l9.428 5.81V250z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F9",
    fillRule: "nonzero",
    d: "m134.882 226.413-9.428-5.809 9.428-5.807 9.428 5.807z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BEE4",
    fillRule: "nonzero",
    d: "m99.497 243.342 10.1-5.837v-16.701l-10.1 5.834z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1F6",
    fillRule: "nonzero",
    d: "m99.497 243.342-10.1-5.837v-16.701l10.1 5.834z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F9",
    fillRule: "nonzero",
    d: "m99.497 226.638-10.1-5.834 10.1-5.833 10.1 5.833z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.962 113.754c7.727-4.465 20.256-4.465 27.982 0 7.728 4.464 7.728 11.702 0 16.166-7.726 4.464-20.256 4.464-27.982 0-7.727-4.464-7.727-11.702 0-16.166Z",
    fill: "url(#EmptyAnalyticsTopic_svg__m)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M131.08 109.896c7.728-4.465 20.256-4.465 27.984 0 7.728 4.464 7.728 11.703 0 16.166-7.728 4.464-20.255 4.464-27.984 0-7.725-4.463-7.725-11.702 0-16.166Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m150.052 35.536-.145 47.454c-.012 4.309-4.672 6.999-8.41 4.856l-40.6-23.295a5.611 5.611 0 0 1-2.822-4.803l-.587-48.211c-.054-4.364 4.665-7.116 8.432-4.924l41.341 24.05a5.611 5.611 0 0 1 2.791 4.873Z",
    fill: "#2E3192",
    fillRule: "nonzero",
    opacity: 0.26
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m164.377 37.21-.32 50.91a4.13 4.13 0 0 0 2.039 3.59 4.125 4.125 0 0 0 4.126.03l58.235-33.267a4.13 4.13 0 0 0 2.082-3.61l-.283-50.756a4.126 4.126 0 0 0-6.183-3.56l-57.626 33.106a4.135 4.135 0 0 0-2.07 3.556Z",
    fill: "#FF9D33",
    fillRule: "nonzero",
    opacity: 0.31
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(168.796 3.778)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "EmptyAnalyticsTopic_svg__p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EmptyAnalyticsTopic_svg__n"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.329 37.208 0 88.118a4.126 4.126 0 0 0 6.174 3.614L64.41 58.472a4.13 4.13 0 0 0 2.083-3.61L66.21 4.107A4.126 4.126 0 0 0 60.027.548L2.402 33.653a4.132 4.132 0 0 0-2.073 3.555Z",
    fill: "url(#EmptyAnalyticsTopic_svg__o)",
    fillRule: "nonzero",
    mask: "url(#EmptyAnalyticsTopic_svg__p)"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m179.89 44.656-.055 8.453a.686.686 0 0 0 1.025.6l9.673-5.522a.687.687 0 0 0 .346-.6l-.047-8.426a.686.686 0 0 0-1.026-.591l-9.568 5.495a.687.687 0 0 0-.349.59Zm14.392-7.662-.055 8.454a.686.686 0 0 0 1.025.6l9.669-5.522a.687.687 0 0 0 .345-.6l-.046-8.427a.686.686 0 0 0-1.027-.59l-9.567 5.495a.687.687 0 0 0-.344.59Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m208.96 28.738-.05 8.454a.686.686 0 0 0 1.026.6l9.668-5.521a.687.687 0 0 0 .346-.6l-.047-8.427a.687.687 0 0 0-1.028-.59l-9.572 5.5a.684.684 0 0 0-.344.584Z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.42
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m194.567 51.008-.055 8.453a.686.686 0 0 0 1.025.6l9.669-5.521a.687.687 0 0 0 .345-.6l-.048-8.427a.686.686 0 0 0-1.026-.59l-9.566 5.495a.687.687 0 0 0-.344.59Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m179.89 58.932-.055 8.453a.686.686 0 0 0 1.025.598l9.673-5.522a.686.686 0 0 0 .346-.598l-.047-8.428a.686.686 0 0 0-1.026-.59l-9.568 5.496a.686.686 0 0 0-.349.59Z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.42
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.054 7.54)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "EmptyAnalyticsTopic_svg__s",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EmptyAnalyticsTopic_svg__q"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m52.564 29.691-.143 47.456c-.014 4.308-4.672 6.997-8.41 4.856L3.41 58.708a5.611 5.611 0 0 1-2.82-4.803L0 5.694C-.053 1.33 4.665-1.422 8.434.77l41.34 24.05a5.611 5.611 0 0 1 2.79 4.871Z",
    fill: "url(#EmptyAnalyticsTopic_svg__r)",
    fillRule: "nonzero",
    mask: "url(#EmptyAnalyticsTopic_svg__s)"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m112.522 28.914-.017 7.723a.913.913 0 0 1-1.367.79l-6.61-3.79a.918.918 0 0 1-.467-.779l-.095-7.847a.914.914 0 0 1 1.372-.8l6.728 3.912a.916.916 0 0 1 .456.79Z",
    fill: "#FF9D33",
    fillRule: "nonzero"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m102.081 50.615 8.697-5.012a.849.849 0 0 1 1.215.43l5.886 15.273a.849.849 0 0 0 1.11.482l18.813-7.599h0",
    stroke: "#FF9D33",
    strokeWidth: 1.698,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M159.064 126.062c-7.728 4.464-20.255 4.464-27.984 0-3.863-2.232-5.795-5.158-5.795-8.083v3.857c0 2.926 1.932 5.853 5.795 8.084 7.729 4.464 20.256 4.464 27.984 0 3.864-2.23 5.796-5.158 5.796-8.084v-3.857c0 2.925-1.932 5.85-5.796 8.083Z",
    fill: "url(#EmptyAnalyticsTopic_svg__t)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalyticsTopic_svg__u)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M79.2 182.012h22.864v4.206H79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalyticsTopic_svg__v)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M68.781 175.945h22.86v4.204h-22.86z"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M66.368 178.852c0-3.302 2.093-3.399 2.093-3.399s1.131 0 2.973-.764c1.815-.754 4.374-.463 2.944 2.177a.656.656 0 0 1-.049.098c-.119.171-.278.31-.463.407l-4.572 2.684c-.697.397-2.91-.523-2.926-1.203Z",
    fill: "url(#EmptyAnalyticsTopic_svg__w)",
    fillRule: "nonzero"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M66.381 178.557c.04.677 2.223 1.58 2.913 1.185l4.572-2.682c.228-.136.444-.293.643-.47-.041.09-.078.178-.131.276a.656.656 0 0 1-.049.098c-.119.171-.278.31-.463.407l-4.572 2.684c-.652.372-2.635-.411-2.897-1.072a.744.744 0 0 1-.02-.133 2.028 2.028 0 0 1 .004-.293Z",
    fill: "#121047",
    fillRule: "nonzero"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M67.219 175.02c.54 0 2.435.482 2.435.482.014.176.073.345.17.492.018.02.035.042.053.064.374.26.754.672-.134 1.229a1.232 1.232 0 0 1-1.598-.113 1.45 1.45 0 0 0-.516-.587 1.29 1.29 0 0 0-.494-.208.289.289 0 0 0-.003-.045s-.139-1.314.087-1.314Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M67.433 142.725c2.068.038 6.985.127 9.05.163-.768 6.217-2.316 11.862-3.35 17.885-1.11 5.85-2.36 9.964-3.45 14.833-.4.905-2.229.563-2.598-.31-.29-4.484-.623-9.947.706-15.122-.222-5.577-.968-10.96-.358-17.449Z",
    fill: "url(#EmptyAnalyticsTopic_svg__x)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M76.789 184.922c0-3.303 2.091-3.4 2.091-3.4s1.132 0 2.974-.763c1.814-.755 4.374-.464 2.945 2.176a.952.952 0 0 1-.05.098 1.28 1.28 0 0 1-.465.407l-4.57 2.683c-.697.398-2.91-.521-2.925-1.201Z",
    fill: "url(#EmptyAnalyticsTopic_svg__y)",
    fillRule: "nonzero"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8 184.625c.04.678 2.224 1.581 2.914 1.185l4.57-2.68c.229-.137.445-.295.645-.47-.043.09-.077.177-.13.275a.952.952 0 0 1-.05.098 1.28 1.28 0 0 1-.465.407l-4.57 2.683c-.651.373-2.635-.41-2.897-1.07a.628.628 0 0 1-.02-.134 2.215 2.215 0 0 1 .003-.294Z",
    fill: "#121047",
    fillRule: "nonzero"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M77.64 181.087c.537 0 2.434.484 2.434.484.015.175.073.344.168.492.02.02.036.042.053.064.375.26.757.671-.132 1.23a1.232 1.232 0 0 1-1.598-.114 1.475 1.475 0 0 0-.515-.586 1.325 1.325 0 0 0-.495-.209.315.315 0 0 0-.005-.043s-.137-1.318.09-1.318Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M73.743 157.504c-.565-2.672-7.648-3.084-6.33-13.512 2.046-.302 12.036 4.541 14.08 4.24.255 6.257-.348 12.083-.387 18.19-.139 5.953-.701 10.215-.984 15.198-.245.96-2.104.92-2.613.12-1.017-4.377-2.237-9.714-1.77-15.035-.609-2.948-1.334-6.071-1.996-9.201Z",
    fill: "url(#EmptyAnalyticsTopic_svg__z)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M68.064 128.62c-.634-2.106-1.234-9.71-1.07-11.663.165-1.953 2.878-10.906 2.878-10.906.714.362 2.019.931 2.019.931-.283 1.229-1.983 8.891-2.023 10.412-.04 1.52.505 7.105 1.133 7.708.629.602-2.937 3.518-2.937 3.518Z",
    fill: "url(#EmptyAnalyticsTopic_svg__A)",
    fillRule: "nonzero"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M86.323 113.107c-.36 1.667-1.782 6.904-3.006 9.604-.593 1.307-2.493 3.07-3.878 4.142a1.601 1.601 0 0 1-1.804.103c-.503-.3-1.077-.689-1.687-1.132-1.47-1.067-2.498-2.123-3.2-2.187-5.784-.518-5.498 8.807-5.719 20.57.759 2.81 2.63 4.448 4.794 5.362 4.395 1.857 8.723 1.375 9.878-1.645-1.15-5.254-2.057-9.395-1.565-14.608a19.96 19.96 0 0 0 6.253-8.818c1.341-3.979 2.05-9.716 2.132-10.738 0 0-.93-.288-2.198-.653Z",
    fill: "url(#EmptyAnalyticsTopic_svg__B)",
    fillRule: "nonzero"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M69.43 125.096c.921-1.214.957-2.958.78-4.174a6.014 6.014 0 0 1-.359-2.099c.018-2.706 1.755-5.032 3.865-4.871 4.25.32 3.478 2.553 3.46 5.257-.016 2.507-1.164 4.225-3.066 4.503-.002.412.552.997 1.036 1.502-1.086 1.203-3.14 1.418-4.011 1.306-.929-.121-2.084-.682-1.704-1.424Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M75.32 112.531c-.123-.33-.778-.512-2.918.466-.013.008-.52.24-.55.257-3.947 2-2.683 6.618-2.002 7.824.282.43.425.938.409 1.453 1.59-.163 2.148.703 3.114-.253.692-.685 1.741-1.502 1.906-1.827.119-.243.154-.518.102-.783-.131-2.243.987-.936.983-.42.411-.231.33-1.131.239-2.13 3.284-2.78 1.33-4.438-1.284-4.587Z",
    fill: "#121149",
    fillRule: "nonzero"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M86.545 113.171c.094-.31.128-.904-.134-1.19-.26-.287-.57-1.726.268-1.946-.03-.27.592-.916 1.543-.37.952.546 1.25 1.446.999 2.021s-.832 1.523-.918 2.007c-.316-.095-1.758-.522-1.758-.522ZM70.077 106.153c.122-.44-.27-1.687.027-2.282.298-.595.766-1.18 1.563-.821.798.36 1.076.839 1.012 1.264a.891.891 0 0 1-.164 1.307c-.564.456-.738.688-.876 1.25-.3-.133-1.562-.718-1.562-.718Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  }))));
};
export default SvgEmptyAnalyticsTopic;